export const SNAPSHOT_UNDO_STACK_DEFAULT_LIMIT = 100;

export const pushSnapshot = <T>(
  stack: T[],
  snapshot: T,
  limit: number = SNAPSHOT_UNDO_STACK_DEFAULT_LIMIT,
): T[] => {
  const next = [...stack, snapshot];
  if (next.length > limit) {
    return next.slice(next.length - limit);
  }
  return next;
};

export const popSnapshot = <T>(
  stack: T[],
): { previous: T | undefined; remaining: T[] } => {
  if (stack.length === 0) {
    return { previous: undefined, remaining: stack };
  }
  const remaining = [...stack];
  const previous = remaining.pop();
  return { previous, remaining };
};
